import { ScreenName } from '../lib/enums';

// No route means the standalone IdleScreen that MainNavigator renders while loading
export const isIdleRoute = (routeName?: string): boolean =>
  routeName === undefined || routeName === ScreenName.IDLE;
